const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const AUTH_API = `${BACKEND_URL}/api/auth`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const signInWithGoogle = () => {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export async function fetchMe() {
  const r = await fetch(`${AUTH_API}/me`, { credentials: "include" });
  if (!r.ok) throw new Error("Not authenticated");
  return r.json();
}

export async function exchangeSession(sessionId) {
  const r = await fetch(`${AUTH_API}/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!r.ok) throw new Error("Session exchange failed");
  return r.json();
}

export async function logout() {
  await fetch(`${AUTH_API}/logout`, { method: "POST", credentials: "include" });
}
